<img class="logo" src="./assets/images/logo.svg" alt="Logo FrontForce Emergency" [width]="size" [height]="size" />
